import React from 'react';
import { Link } from 'react-router'
import './styles/Areas.scss'

const rowStyle = {
  'justifyContent': 'space-between'
}

const AreaCategoriesMenu = (props) => {
  const { categories, active, professionSelection } = props;

  return <div className="areas-menu row scroll-h" style={rowStyle}>
    { categories.filter(cat => {
      return cat.practice_type == professionSelection
    }).map(category => <Link to={`/page/therapy_categories/${category._id}`}
      className={"category-container "+(active === category._id && 'active')}
      key={`area-menu-${category._id}`}>
      {category.image && <img
        alt={category.name}
        title={category.name}
        style={{'verticalAlign': 'middle'}}
        className="category-icon"
        src={require('../../images/icons/categories/'+category.image)} />
      }
      <caption>{category.name}</caption>
    </Link>)}
  </div>
}

AreaCategoriesMenu.defaultProps = {
  categories: [],
  active: ''
}

export default AreaCategoriesMenu;



// WEBPACK FOOTER //
// ./src/components/home/AreaCategoriesMenu.jsx